import HomeModernIcon from "@heroicons/react/24/solid/HomeModernIcon";
import {
  Avatar,
  Card,
  CardContent,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";

const CardNews = (props) => {
  const { sx, personAggregate } = props;
  const news = personAggregate.people.taggedNews;

  return (
    <Card sx={sx}>
      <CardContent>
        <Stack
          alignItems="flex-start"
          direction="row"
          justifyContent="space-between"
          spacing={3}
        >
          <Stack spacing={1}>
            <Typography color="text.secondary" variant="overline">
              Notizie verificate
            </Typography>
            <Typography variant="h4">{`${news}`}</Typography>
          </Stack>
          <Avatar
            sx={{
              backgroundColor: "news.main",
              height: 56,
              width: 56,
            }}
          >
            <SvgIcon>
              <HomeModernIcon />
            </SvgIcon>
          </Avatar>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default CardNews;
